import { useContext } from "react";
import { ReportContext } from "../../contexts/reportContext";

export function useReportContext(params) {
  const values = useContext(ReportContext);

  return values;
}
